/** 발행 정보는 준비가 끝난 뒤 이 설정에 등록한다. 등록만으로 출시되지는 않는다. */
export type SummaryPdfPublication = {
  isbn: string;
  publishedAt: string;
  previews: { src: string; alt: string }[];
  versions: { version: string; date: string; description: string; blobPath: string }[];
};
export const SUMMARY_PDF_2027_1 = {
  sessionId: "2027-1",
  displayName: "2027년 1회",
  plannedReleaseDate: "2026-11-01",
  enabled: true as boolean,
  releaseAt: "2026-11-01T12:00:00+09:00" as string | null,
  products: [
    { id: "27-1-compressed-pdf", title: "2027년 1회 실기 이론 요약 PDF", price: 8800, href: "/summary-pdf/27-1-compressed", publication: null as SummaryPdfPublication | null },
    { id: "27-1-coding-pdf", title: "2027년 1회 실기 코딩 요약 PDF", price: 8800, href: "/summary-pdf/27-1-coding-compressed", publication: null as SummaryPdfPublication | null },
  ],
  bundle: { id: "27-1-summary-pdf-bundle", title: "2027년 1회 요약 PDF 2종 묶음", href: "/summary-pdf/bundle", price: 15840, discountRate: 10 },
} as const;

export function isSummaryPdfBundle(productId: unknown): boolean {
  return productId === SUMMARY_PDF_2027_1.bundle.id;
}
export function summaryPdfComponents(productId: unknown): readonly string[] {
  if (isSummaryPdfBundle(productId)) return SUMMARY_PDF_2027_1.products.map(product => product.id);
  return SUMMARY_PDF_2027_1.products.some(product => product.id === productId) ? [productId as string] : [];
}
export function isUpcomingSummaryPdfProduct(productId: string): boolean {
  return summaryPdfComponents(productId).length > 0;
}
export function summaryPdfProductsOverlap(left: unknown, right: unknown): boolean {
  const targets = summaryPdfComponents(left);
  return summaryPdfComponents(right).some(id => targets.includes(id));
}

/** 일정·발행 정보·명시적인 공개 승인이 모두 준비되어야 판매한다. */
export function isSummaryPdfLaunchOpen(now: number | string | Date = Date.now()): boolean {
  const { enabled, releaseAt, plannedReleaseDate, products } = SUMMARY_PDF_2027_1;
  if (!enabled || !releaseAt) return false;
  const release = Date.parse(releaseAt);
  return release >= Date.parse(`${plannedReleaseDate}T00:00:00+09:00`) && new Date(now).getTime() >= release && products.every(({ publication }) =>
    publication && /^\d{13}$/.test(publication.isbn) && Number.isFinite(Date.parse(publication.publishedAt)) &&
    publication.previews.length > 0 && publication.versions.length > 0 &&
    publication.versions.every(version => version.blobPath.trim() && version.version.trim())
  );
}
